// See NeutralAvatar for why these are inline SVG components. This mark differs
// from the neutral one only by a slightly narrower, more sloped shoulder line.
export default function FemaleAvatar({ className = "", title = "No profile photo", ...props }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="32" r="32" className="fill-slate-100" />
      <circle cx="32" cy="25" r="10" className="fill-slate-400" />
      <path d="M15 60c0-11 7.5-19 17-19s17 8 17 19v4H15v-4Z" className="fill-slate-400" />
    </svg>
  );
}
